// Adapter from a Firestore venue doc to VenueCardPreview's prop shape.
// The two differ (`venue.name` vs `venueData.title`), so passing a raw
// venue straight in silently renders the "Venue Title" placeholder.
// Every caller of VenueCardPreview should map through here.
//
// Deliberately kept out of VenueCardPreview.js: several test suites
// jest.mock that module with a default-export-only factory, which would
// strip a named export off it and break unrelated pages at runtime.
export function toPreviewData(venue) {
  if (!venue) return null;

  return {
    title: venue.name,
    address: venue.address,
    phone: venue.phone || '',
    website: venue.website || '',
    category: venue.category || '', // Primary (legacy) category
    categories:
      venue.categories && venue.categories.length > 0
        ? venue.categories
        : venue.category
          ? [venue.category]
          : [],
    images: venue.images || [],
    video: venue.video || null,
    description: venue.description || '',
    socialLinks: venue.socialLinks || {
      instagram: '',
      facebook: '',
      tiktok: '',
    },
    hours: venue.hours || null,
    cardBorderStyle: venue.cardBorderStyle,
    // Card-visible discovery fields. `offers` is filtered to what a guest
    // would actually see right now — the consumer app applies the same
    // active/expiry test client-side, so previewing the raw list would show
    // the owner promos their customers can't see.
    offers: activeOffers(venue.offers),
    dressCode: venue.dressCode || '',
    coverCharge:
      typeof venue.coverCharge === 'number' ? venue.coverCharge : null,
  };
}

// Mirrors the consumer app's offer filter: live, in-window, and scheduled for
// today. daysOfWeek uses 0=Sun…6=Sat, matching JS getDay().
function activeOffers(offers) {
  if (!Array.isArray(offers)) return [];
  const now = new Date();
  const today = now.getDay();

  return offers.filter((offer) => {
    if (!offer || offer.active === false) return false;
    if (offer.validUntil) {
      const until = offer.validUntil.toDate
        ? offer.validUntil.toDate()
        : new Date(offer.validUntil);
      if (!Number.isNaN(until.getTime()) && until < now) return false;
    }
    if (Array.isArray(offer.daysOfWeek) && offer.daysOfWeek.length > 0) {
      return offer.daysOfWeek.includes(today);
    }
    return true;
  });
}
